import type { BrowserSettings, SearchProvider } from './types';

export const APP_NAME = 'WebSurf';

export const SEARCH_ENGINES: Record<SearchProvider, { label: string; template: string; note: string }> = {
  google: {
    label: 'Google',
    template: 'websurf://search?engine=google&q=%s',
    note: 'WebSurf-native Google-style results. Falls back automatically when Google returns bot checks.'
  },
  duckduckgo: {
    label: 'DuckDuckGo',
    template: 'websurf://search?engine=duckduckgo&q=%s',
    note: 'WebSurf-native privacy search. Avoids the broken embedded DuckDuckGo JavaScript page.'
  },
  custom: {
    label: 'Custom',
    template: 'https://www.google.com/search?igu=1&q=%s',
    note: 'Use your own search URL template. Include %s where the query should go.'
  }
};

export const DEFAULT_SETTINGS: BrowserSettings = {
  searchProvider: 'google',
  searchEngine: SEARCH_ENGINES.google.template,
  homepage: 'websurf://home',
  openHomepageOnNewTab: true,
  autoTranslate: false,
  translateTarget: 'en',
  reducedMotion: false,
  proxyTimeoutMs: 90000,
  showBookmarksBar: true,
  passwordVaultEnabled: true,
  compatibilityMode: true,
  proxyCacheEnabled: true,
  preferReadableFallback: true,
  defaultRenderMode: 'smart'
};

export const SMART_DIRECT_HOSTS = [
  'neal.fun',
  'poki.com',
  'itch.io',
  'github.io',
  'games.crazygames.com',
  'gameframe.crazygames.com',
  'html5.gamedistribution.com'
];

export const GAME_COMPAT_HOSTS = [
  'crazygames.com',
  'poki.com',
  'hypackel.com',
  'hypackellite.github.io',
  'hypackel.github.io'
];

export const GROUP_COLORS = ['#57a7b3', '#434242', '#78c4cf', '#2f737c', '#8a8787', '#6bbf9d', '#d0b057'];

export const ERROR_PAGE_FILES: Record<string, string> = {
  offline: '/offline.html',
  error: '/error.html',
  timeout: '/timeout.html',
  'site-unavailable': '/site-unavailable.html',
  dns: '/site-unavailable.html'
};
